import { useEffect, useRef } from "react";
import {getAnalytics, logEvent} from 'firebase/analytics';
import {useLocation} from 'react-router-dom';
import {firebaseAnalytics} from '../AuthProvider/firebaseConfig';

const analytics = firebaseAnalytics;

export const useActionAnalytics = (actionType: string | undefined,
                                   actionTypeSubmitting: string | undefined,
                                   container: string,
                                   metadata: Record<string, unknown> = {},
                                   isActive: boolean,
                                   isActiveSubmitting: boolean) => {

  const metadataRef = useRef(metadata);
  const actionTypeRef = useRef(actionType);
  const actionTypeSubmittingRef = useRef(actionTypeSubmitting);
  const isDebug = process.env.REACT_APP_FIREBASE_DEBUG_MODE === "true";
  const { pathname } = useLocation();

  metadataRef.current = metadata;
  actionTypeRef.current = actionType;
  actionTypeSubmittingRef.current = actionTypeSubmitting;

  useEffect(() => {
    if (!actionType || !isActive) return;

    logEvent(analytics, "action_type", {
      action_type: actionTypeRef.current,
      container: container,
      page_path: pathname,
      page_location: window.location.href,
      ...(isDebug && { debug_mode: true }),
      ...metadataRef.current
    });

  }, [actionType, isActive]);

  useEffect(() => {
    if (!actionTypeSubmitting || !isActiveSubmitting) return;

    logEvent(analytics, "action_type_submitting", {
      action_type: actionTypeSubmittingRef.current,
      container: container,
      page_path: pathname,
      page_location: window.location.href,
      ...(isDebug && { debug_mode: true }),
      ...metadataRef.current
    });

  }, [actionTypeSubmitting, isActiveSubmitting]);
};

export const logActionEvent = (eventName: string, container: string, actionType: string, metadata: Record<string, unknown> = {}) => {
  const isDebug = process.env.REACT_APP_FIREBASE_DEBUG_MODE === "true";
  logEvent(analytics, eventName, {
    action_type: actionType,
    container: container,
    page_path: window.location.pathname,
    page_location: window.location.href,
    ...(isDebug && { debug_mode: true }),
    ...metadata
  });
};